import { Outlet } from "react-router-dom";

const StarterLayout = () => {
  return (
    <div className="flex min-h-screen w-full flex-col items-stretch justify-center bg-gradient-to-br from-blue-50 to-blue-100">
      <Outlet />
    </div>
  );
};

export default StarterLayout;
